import GenericModalWrapper from '../../ui/modal'

const CouponExpiryModal = ({
    primaryText,
    secondaryText,
    primaryCTA,
    onPrimaryClick,
    secondaryCTA,
    onSecondaryClick
}: {
    primaryText: string
    secondaryText: string
    primaryCTA: string
    onPrimaryClick: () => void
    secondaryCTA: string
    onSecondaryClick: () => void
}) => {
    return (
        <GenericModalWrapper
            open={true}
            primaryText={primaryText}
            secondaryText={secondaryText}
            primaryCTA={primaryCTA}
            onPrimaryClick={onPrimaryClick}
            variant="warning"
            secondaryCTA={secondaryCTA}
            onSecondaryClick={onSecondaryClick}
        />
    )
}

export default CouponExpiryModal
